import React from "react";
import { Link } from "react-router-dom";
import styles from "./BookShipments.module.scss";
import bookingImage from "../../resources/images/POSTER-HFI.png";
import Button from "../common-ui/button/Button";

const BookShipments = () => {
  const handleClick = (e: React.FormEvent) => {
    e.preventDefault();
    window.location.href = "https://hfi-dashboard.mfsys.ca/auth/login";
  };
  return (
    <div className={styles.bookShipmentsMain}>
      <div className={styles.bookShipmentsContainer}>
        {/* Book Shipments Section */}
        <div className={styles.bookShipmentsSection}>
          {/* Left Section - Poster Image */}
          <div className={styles.posterLeft}>
            <img
              src={bookingImage}
              alt="Book Shipment Online"
              loading="lazy"
              className={styles.posterImage}
            />
          </div>

          {/* Right Section - Content */}
        </div>

        {/* Right Section - News */}
        <div className={styles.newsSection}>
          <h2 className={styles.newsTitle}>Join our Freight Network</h2>
          <div className={styles.newsContent}>
            <span className={styles.newsHighlight}>
              Get Started with Your Smart Freight Dashboard - Take control of
              your shipments with our easy-to-use online platform.
            </span>
            <br />
            <span className={styles.createAccountText}>
              Create your free account today to:
            </span>
            <br className={styles.newsLineBreak} />
            <ul>
              <li>Track your shipments in real time.</li>
              <li>Update your profile and preferences instantly.</li>
              <li>Chat directly with our dedicated support team.</li>
            </ul>
            <span className={styles.newsHighlight}>
              Stay informed, stay connected, and streamline your logistics—all
              in one place. Sign up now and experience Hands-On Transportation
              at your fingertips!
            </span>
          </div>
          <Button
            className={styles.joinNetworkButton}
            onClick={handleClick}
            text="Join our Network"
          />
        </div>
      </div>
    </div>
  );
};

export default BookShipments;
